var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-ui-text-color mute cursor-pointer absolute",on:{"click":_vm.handleMute}},[(_vm.muted)?_c('i',{staticClass:"theme-question-shadow fas fa-volume-mute"}):_vm._e(),(!_vm.muted)?_c('i',{staticClass:"theme-question-shadow fas fa-volume-up"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }